/* SLIDE 27 */
/* SLIDE 28 */

import React, { useEffect, useState } from "react";
import iconWarning from "assets/icons/iconWarning.svg";
import { logoutAttendance, loginAttendance, getUserWorkingTime } from "features/user/usecases/UserUsecases";
import { useSelector, useDispatch } from "react-redux";
import { setShowBack, setShowMenu } from "shared/store/headerSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { setAppLoading } from "../../../shared/store/headerSlice";
import closeIcon from 'assets/icons/close.svg';
import { logoutThunk } from "features/auth/presentation/store/authSlice";
import { DateTime } from "luxon";
import Skeleton from 'react-loading-skeleton';
import Popup from "shared/components/Popup";
import { getFormattedTime } from "../../../utils/common";
import { use } from "react";
import { STORAGE_KEYS } from "../../../hooks/useAttendanceCheck";

const UserWorkingTime = () => {
  const { user, serverTime } = useSelector((state) => state.auth);
  const { alertCheckout } = useSelector((state) => state.header);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();


  const [checkinTime, setCheckinTime] = useState("");
  const [checkoutTime, setCheckoutTime] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [hasCheckedIn, setHasCheckedIn] = useState(false);
  const [hasCheckedOut, setHasCheckedOut] = useState(false);
  const [isCheckingOut, setIsCheckingOut] = useState(false);
  const [attendanceNote, setAttendanceNote] = useState("");
  const [leaveWorkNote, setLeaveWorkNote] = useState("");
  const [loadingPage, setLoadingPage] = useState(true);
  const [showPopupCheckout, setShowPopupCheckout] = useState(false);
  const [latestMemo, setLatestMemo] = useState("");
  const [currentDateTime, setCurrentDateTime] = useState(serverTime);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(prevDateTime => {
        const newDateTime = new Date(prevDateTime);
        newDateTime.setSeconds(newDateTime.getSeconds() + 1);
        return newDateTime;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const checkUserWorkingTime = async () => {
    try {
      setLoadingPage(true);
      const response = await getUserWorkingTime({
        parkingId: user?.parkingId,
        userId: user?.userId,
      });

      const data = response?.data;
      setLatestMemo(data?.latestMemo || "");
      if (data?.attendanceDate) {
        const savedCheckinTime = DateTime.fromFormat(data?.attendanceDate, "yyyyMMddHHmmss", { setZone: true }).toFormat("yyyy-MM-dd HH:mm:ss");
        const savedNote = data?.attendanceNote || "";
        setCheckinTime(savedCheckinTime);
        setAttendanceNote(savedNote);
        localStorage.setItem(STORAGE_KEYS.CHECKIN_TIME, savedCheckinTime);
        localStorage.setItem(STORAGE_KEYS.ATTENDANCE_NOTE, savedNote);
        setHasCheckedIn(true);
        dispatch(setShowBack(true));
        dispatch(setShowMenu(true));
      } else {
        setHasCheckedIn(false);
        setCheckinTime("");
        setAttendanceNote("");
        localStorage.removeItem(STORAGE_KEYS.CHECKIN_TIME);
        localStorage.removeItem(STORAGE_KEYS.ATTENDANCE_NOTE);
      }
      if (data?.leaveWorkDate) {
        const savedCheckoutTime = DateTime.fromFormat(data?.leaveWorkDate, "yyyyMMddHHmmss", { setZone: true }).toFormat("yyyy-MM-dd HH:mm:ss");
        const leaveNote = data?.leaveWorkNote || "";
        setCheckoutTime(savedCheckoutTime);
        setLeaveWorkNote(leaveNote);
        localStorage.setItem(STORAGE_KEYS.CHECKOUT_TIME, savedCheckoutTime);
        localStorage.setItem(STORAGE_KEYS.LEAVE_WORK_NOTE, leaveNote);
        setHasCheckedOut(true);
      } else {
        setHasCheckedOut(false);
        setCheckoutTime("");
        setLeaveWorkNote("");
        localStorage.removeItem(STORAGE_KEYS.CHECKOUT_TIME);
        localStorage.removeItem(STORAGE_KEYS.LEAVE_WORK_NOTE);
      }
      console.log("response", response);
    } catch (error) {
      console.error("Error fetching user working time:", error);
    } finally {
      setLoadingPage(false);
    }
  }
  // Check localStorage when load page
  useEffect(() => {
    if (location?.state?.from != 'login') {
      checkUserWorkingTime();
    } else {
      setLatestMemo(location?.state?.latestMemo || "");
      setLoadingPage(false);
    }
  }, []);

const handleCheckin = async () => {
  if (hasCheckedIn) return;
  dispatch(setAppLoading(true));

  try {

    const result = await loginAttendance({
      parkingId: user?.parkingId,
      userId: user?.userId,
      attendanceNote: attendanceNote
    });
    dispatch(setAppLoading(false));
    let data = result?.data;
    if (result) {
      setCheckinTime(DateTime.fromFormat(data?.attendanceDate, "yyyyMMddHHmmss", { setZone: true }).toFormat("yyyy-MM-dd HH:mm:ss"));
      setAttendanceNote(attendanceNote || "");
      localStorage.setItem(STORAGE_KEYS.ATTENDANCE_NOTE, attendanceNote || ""); // save localStorage
      localStorage.setItem(STORAGE_KEYS.CHECKIN_TIME, DateTime.fromFormat(data?.attendanceDate, "yyyyMMddHHmmss", { setZone: true }).toFormat("yyyy-MM-dd HH:mm:ss")); // save localStorage

      setShowNotification(true);
      setIsCheckingOut(false);

      dispatch(setShowBack(true));
      dispatch(setShowMenu(true));

      setTimeout(() => {
        setShowNotification(false);
        setHasCheckedIn(true);
        navigate("/menu_manager", { replace: true });
      }, 2000);
    } else {
      alert("Fail!");
    }

  } catch (error) {
    dispatch(setAppLoading(false));
  }
};

const handleCheckout = () => {
  if (hasCheckedOut) return;
  if (alertCheckout) {
    setShowPopupCheckout(true);
  } else {
    setShowPopup(true);
  }
};

const handleConfirmCheckout = async () => {
  dispatch(setAppLoading(true));
  setShowPopupCheckout(false);
  try {
    const result = await logoutAttendance({
      parkingId: user?.parkingId,
      userId: user?.userId,
      leaveWorkNote: leaveWorkNote
    });
    
    if (result) {
      setCheckoutTime(result?.leaveTime);
      localStorage.setItem(STORAGE_KEYS.CHECKOUT_TIME, result?.leaveTime); // save localStorage
      dispatch(setAppLoading(false));
      setHasCheckedOut(true);
      setShowPopup(false);
      setIsCheckingOut(true);
      setShowNotification(true);

      setTimeout(() => {
        setShowNotification(false);
        // navigate("/menu_manager", { replace: true });
        dispatch(logoutThunk({
          id: user?.userId.trim(),
          parkingId: user?.parkingId.trim(),
        }))
        
      }, 2000);
    } else {
      dispatch(setAppLoading(false));
      alert("Fail!");
    }
  }
  catch (error) {
    dispatch(setAppLoading(false));
  }
};

const handleCancelCheckout = () => {
  setShowPopup(false);
};
return (
  loadingPage ? <UserWorkingTimeSkeleton /> : <div className="checkout-container">
    <div className="content-time-attendance nl-content-time-attendance">
      <div className="input-group">
        <div className="input-label">
          <span>이전메모</span>
          <span className="time-label" style={{ fontSize: "13px" }}>
            {latestMemo?.leaveWorkDate && DateTime.fromFormat(latestMemo?.leaveWorkDate, "yyyyMMddHHmmss").toFormat("yyyy-MM-dd HH:mm:ss")}
          </span>
        </div>
        <div className="input-container" style={{ borderRadius: "6px" }}>
          <textarea
            className="nl-show-scrollbar"
            type="text"
            placeholder=""
            readOnly={true}
            value={latestMemo?.leaveWorkNote || ""}/>
        </div>
      </div>
      <button
        className={`checkout-button mt-20 ${hasCheckedIn ? "checked-in" : ""}`}
        style={hasCheckedOut ? { backgroundColor: "#ccc" } : {}}
        onClick={hasCheckedIn ? handleCheckout : handleCheckin}
        disabled={hasCheckedOut}
      >
        {hasCheckedOut ? "퇴근완료" : hasCheckedIn ? "퇴근하기" : "출근하기"}
      </button>



      <div className="input-group">
        <div className="input-label">
          <span>출근메모</span>
          <span className="time-label" style={{ fontSize: "13px" }}>

            {checkinTime ? checkinTime : currentDateTime ? getFormattedTime(currentDateTime, "yyyy-MM-dd HH:mm:ss") : <span className="dash-label">-</span>}
          </span>
        </div>
        <div className="input-container" style={{ borderRadius: "6px" }}>
          <textarea
            className="nl-show-scrollbar"
            type="text"
            placeholder={!hasCheckedIn || hasCheckedOut ? "그날의 주요사항이나 전달사항을 입력하세요." : ""}
            readOnly={hasCheckedIn}
            value={attendanceNote}
            onChange={
              (e) => {
                setAttendanceNote(e.target.value)
                localStorage.setItem(STORAGE_KEYS.ATTENDANCE_NOTE, e.target.value);
              }}
          />
        </div>
      </div>

      <div className="input-group">
        <div className="input-label">
          <span>퇴근메모</span>
          <span className="time-label">
            {checkoutTime || <span className="dash-label">-</span>}
          </span>
        </div>
        <div className="input-container" style={{ borderRadius: "6px" }}>
          <textarea
            className="nl-show-scrollbar"
            type="text"
            placeholder={hasCheckedIn ? "그날의 주요사항이나 전달사항을 입력하세요." : ""}
            readOnly={!hasCheckedIn || hasCheckedOut}
            value={leaveWorkNote}
            onChange={
              (e) => {
                setLeaveWorkNote(e.target.value)
                localStorage.setItem(STORAGE_KEYS.LEAVE_WORK_NOTE, e.target.value);
              }}
          />
        </div>
      </div>
    </div>
    {showNotification && (
      <div className="notification-overlay ">
        <div
          className={`notification ${isCheckingOut ? "checkout" : "checkin"}`}
        >
          <div className="check-icon">
            <svg viewBox="0 0 24 24" width="60" height="60">
              <circle
                cx="12"
                cy="12"
                r="10"
                fill={isCheckingOut ? "#CC3131" : "#106b46"}
              />
              <path
                d="M9 16.2L5.8 13l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <div className="notification-text">
          {isCheckingOut ? "퇴근하였습니다" : "출근하였습니다"}
        </div>
      </div>
    )}
    {showPopup && (
      <div className="popup-overlay">
        <div className="popup">
          <div
            className="flex justify-center"
            style={{ marginTop: "30px", marginBottom: "35px" }}
          >
            <img src={iconWarning} alt="iconWarning" />
          </div>


          <div className="text-center w-full">
            <h2
              className="text-lg font-bold mb-4 pb-1"
              style={{ marginBottom: "7px" }}
            >
              퇴근확인
            </h2>
            <p className="text-base" style={{ marginBottom: "21px" }}>
              로그아웃을 진행하시면 퇴근이 기록됩니다.
              <br />
              정말로 로그아웃을 진행할까요?
            </p>

            <div className="flex w-full gap-3 pt-8">
              <button
                className="w-1/2 py-2 btn-cancel"
                style={{ fontWeight: 500 }}
                onClick={handleCancelCheckout}
              >
                취소
              </button>
              <button
                className="w-1/2 py-2 btn-confirm"
                style={{ fontWeight: 500 }}
                onClick={handleConfirmCheckout}
              >
                확인
              </button>
            </div>
          </div>
        </div>
      </div>
    )}
    {showPopupCheckout && (
      <Popup
        title="퇴근시간 확인"
        handleYes={handleConfirmCheckout}
        textYes="예"
        textNo="아니오"
        setVisible={setShowPopupCheckout}
        classPopup="htPopupWorkingTime"
      >
        <div className="nl-row f-column">
          <div>퇴근 확인을 진행하시겠습니까?</div>
        </div>


      </Popup>
    )}
  </div>
);
};

export default UserWorkingTime;

const UserWorkingTimeSkeleton = () => {
  return (
    <div style={{ padding: '20px' }}>
      <div style={{ marginBottom: '20px', marginTop: '25%' }}>
        <Skeleton style={{ width: '100%', height: '62px' }} />
      </div>
      <div style={{ marginBottom: '20px' }}>
        <Skeleton style={{ width: '100px', height: '20px', marginBottom: '5px' }} />
        <Skeleton style={{ width: '100%', height: '107px' }} />
      </div>
      <div style={{ marginBottom: '20px' }}>
        <Skeleton style={{ width: '100px', height: '20px', marginBottom: '5px' }} />
        <Skeleton style={{ width: '100%', height: '107px' }} />
      </div>
    </div>
  );
};
